import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import Debug from 'debug';
import { differenceBy, findIndex } from 'lodash-es';
import { AumFormField } from '../aumFormField';

const debug = Debug('aumico:aumico-lib-core-fe:AumDraggableMultiSelect');

/**
 * @title Basic select
 */
@Component({
    selector: 'aum-draggable-multi-select',
    templateUrl: 'aum-draggable-multi-select.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        '../aumFormField/aum-form-field.scss',
        '../aumFormField/aum-form-field-outline.scss',
        '../aumOption/option.scss',
        'aum-draggable-multi-select.scss',
    ],
    host: {
        class: 'aum-select aum-form-field',
    },
    inputs: ['aumFormControl', 'floatLabel'],
})
export class AumDraggableMultiSelect extends AumFormField {
    selectionOptions: INameId[];
    @Input() set options(value: INameId[]) {
        this.selectionOptions = value;
        if (this.aumFormControl != null) {
            this.selectionOptions = this.reorderOptions(value, this.aumFormControl.value);
        }
    }
    @Output() selectionChange = new EventEmitter<INameId[]>();
    @Input() override placeholder: string = undefined;

    selectedOptions: INameId[];
    @ViewChild('draggableMultiSelect', { static: false }) draggableMultiSelect: MatSelect;

    onDrop(event: CdkDragDrop<string[]>) {
        debug('Drop happened! From', event.previousIndex, 'to', event.currentIndex);

        if (this.selectedOptions == null) {
            this.selectedOptions = this.aumFormControl.value;
        }
        moveItemInArray(this.selectionOptions, event.previousIndex, event.currentIndex);

        this.selectedOptions = this.reorderSelectedOptions(this.selectionOptions, this.selectedOptions);

        this.aumFormControl.setValue(this.selectedOptions);
        this.selectionChange.emit(this.selectedOptions);
    }

    close() {
        this.draggableMultiSelect.close();
    }

    override writeValue(value: INameId[]) {
        this.draggableMultiSelect.writeValue(value);
    }

    getSelections(event: MatSelectChange) {
        this.selectedOptions = event.value;
        this.selectionChange.emit(this.selectedOptions);
    }

    private reorderOptions(options: INameId[], selectedOptions: INameId[]): INameId[] {
        const rearrangedOptions: INameId[] = [];
        const unSelectedOptions: INameId[] = [];
        if (selectedOptions != null) {
            rearrangedOptions.push(...selectedOptions);

            // check difference of name as some options are array of string so the id will be fake
            const differenceInSelections: INameId[] = differenceBy(options, selectedOptions, 'name');

            unSelectedOptions.push(...differenceInSelections);
        } else {
            unSelectedOptions.push(...options);
        }
        rearrangedOptions.push(...unSelectedOptions);

        return rearrangedOptions;
    }

    private reorderSelectedOptions(selectionOptions: INameId[], selectedOptions: INameId[]): INameId[] {
        const orderedSelectedOptions: INameId[] = [];

        for (const selectionOption of selectionOptions) {
            const index = findIndex(selectedOptions, selectionOption);
            if (index > -1) {
                orderedSelectedOptions.push(selectionOption);
            }
        }

        return orderedSelectedOptions;
    }
}
